export default __webpack_public_path__ + "afaed3ed049eec401b7470a647392dd0.svg";